// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Definición de la colección LoginColl baked at build time.
// NO EDITAR: se regenera en cada build.

export const COLL_DEF = {
  "name": "LoginColl",
  "tableName": "LoginColl",
  "tablePrefix": "gen",
  "idFieldName": "ROWID",
  "fields": [
    {
      "name": "MAP_IMG_TOP_GOLD",
      "type": "IMG"
    },
    {
      "name": "MAP_IMG_TOP_GREEN",
      "type": "IMG"
    },
    {
      "name": "MAP_TROFEO",
      "type": "T"
    },
    {
      "name": "MAP_TITULO_APP",
      "type": "T"
    },
    {
      "name": "MAP_SUBTITULO_APP",
      "type": "T"
    },
    {
      "name": "MAP_IMG_SEP_HEADER",
      "type": "IMG"
    },
    {
      "name": "MAP_LBL_ACCESO",
      "type": "T"
    },
    {
      "name": "MAP_USUARIO",
      "type": "T"
    },
    {
      "name": "MAP_PASSWORD",
      "type": "X"
    },
    {
      "name": "MAP_CREDENCIAL_INFO",
      "type": "T"
    },
    {
      "name": "MAP_FOOTER",
      "type": "T"
    },
    {
      "name": "MAP_IMG_BOTTOM_GREEN",
      "type": "IMG"
    },
    {
      "name": "MAP_IMG_BOTTOM_GOLD",
      "type": "IMG"
    },
    {
      "name": "ROWID",
      "type": "T",
      "size": 32
    }
  ],
  "special": true
} as const;
